//Core
import {createAsyncThunk} from "@reduxjs/toolkit";
//Types
import {TGetAudienceResponseDataValue} from "@/types/services/audiences/response/getAudiencesResponseTypes";
import {TGetAudiencesRequest} from "@/types/services/audiences/request/getAudiencesRequestTypes";
import {
    FiltrationTypes,
    TFiltrationAPIRequest,
    TFiltrationFilteringRule
} from "@/types/services/filtration/request/filtrationAPIRequestTypes";
import {TAudiencesListItem} from "@/types/redux/audienceTypes";
import {TAudiencesType} from "@/types/filterBlocks/audiencesTypeTypes";
//Services
import {getAudiencesAPI} from "@/services/audienceService";
import {filtrationAPI} from "@/services/filtrationService";
//Redux
import {store} from "@/redux/store";
import {startFetch} from "@/redux/app/appSlice";
//Utils
import {fetchListItems} from "@/utils/fetchListItems";
import {convertFilterValueForAPI} from "@/utils/convertFilterValueForAPI";

export const fetchAudiencesList = createAsyncThunk(
    "audience/fetchAudiencesList",
    async (_, {rejectWithValue}) => {
        const data: TGetAudiencesRequest = {
            user_id: store.getState().user.userId,
        }
        try {
            const response = await getAudiencesAPI(data);
            if (response?.values) {
                const values = response.values.map((item: TGetAudienceResponseDataValue) => {
                    return {
                        ...item,
                        selected: false
                    }
                })
                return values as TAudiencesListItem[];
            } else return []
        } catch (error) {
            return rejectWithValue([]);
        }
    },
    {
        condition: (_data, {getState}) => {
            const {
                app: {fetchList},
            }: any = getState();
            if (fetchList.includes(fetchListItems.getAudiences)) return false;
        },
    }
);

let controller = new AbortController();

export const fetchFiltration = createAsyncThunk(
    "audience/fetchFiltration",
    async (_data, {dispatch}) => {
        const filters = store.getState().filtration.filters;
        const filtering_rules: TFiltrationFilteringRule[] = Object.entries(filters)
            .map(([_id, item]) => {
                return {
                    type: FiltrationTypes[item.type],
                    values: convertFilterValueForAPI(item),
                }
            })
            .filter((item) => item.values.length !== 0)
        const data: TFiltrationAPIRequest = {
            user_id: store.getState().user.userId,
            query_id: store.getState().audience.queryId,
            niche: store.getState().filtration.audienceType as TAudiencesType,
            global_operator: Object.keys(filters).length === 0 ? 'and' : store.getState().filtration.condition,
            filtering_rules
        }
        controller.abort();
        controller = new AbortController();
        dispatch(startFetch(fetchListItems.filtration))
        return await filtrationAPI(data, controller.signal);
    },
)